import {ApplicationRef, Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, Renderer2, ViewContainerRef,} from '@angular/core';
import {provideParent} from 'projects/core/src/public-api';
import {ProjectHolder} from 'projects/app-misc/src/app/modules/project-misc/interfaces/project-holder';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {environment} from 'projects/desktop/src/environments/environment';
import {TrelloChecklist} from 'projects/app-misc/src/app/modules/trello-misc/data/trello-checklist';
import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import {TrelloService} from 'projects/app-misc/src/app/modules/trello-misc/data/trello.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ProjectActivityService} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {ProjectsQuery} from 'projects/app-misc/src/app/modules/project-misc/data/project/projects.query';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {ProjectWindowQuery} from 'projects/app-misc/src/app/modules/project-misc/state/project-window.query';
import {ProjectWindowStore} from 'projects/app-misc/src/app/modules/project-misc/state/project-window.store';
import {ProjectAlert} from 'projects/app-misc/src/app/modules/alert/data/alert';
import {ProjectFile} from 'projects/app-misc/src/app/modules/project-misc/data/project/project-file';
import {HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';
import {PdfPreviewDialogComponent} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import {ProjectActivityDialogComponent} from 'projects/app-misc/src/app/modules/project-misc/view/project-activity-dialog/project-activity-dialog.component';
import {FilesBlockComponent} from 'projects/app-misc/src/app/modules/project-misc/view/blocks/files-block/files-block.component';
import {debounceTime, distinctUntilChanged, filter, takeUntil, tap} from 'rxjs/operators';
import {forkJoin, merge, Subject, timer} from 'rxjs';
import {MatSnackBar, MatSnackBarRef, SimpleSnackBar} from '@angular/material/snack-bar';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Notification} from 'projects/app-misc/src/app/modules/notification/data/notification';
import {ConfirmationService} from 'primeng/api';
import {MvcExceptionResponse} from 'projects/core/src/lib/core/data/mvc-exception-response';
import {User} from 'projects/core/src/lib/login/data/user';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {ContactInfo} from '../../../../../../../app-misc/src/app/modules/customer/data/contactInfo';

@Component({
  selector: 'app-project-window',
  templateUrl: './project-window.component.html',
  styleUrls: ['./project-window.component.scss'],
  providers: [
    provideParent(ProjectHolder, ProjectWindowComponent),
    ProjectWindowQuery,
    ProjectWindowStore,
    FilesBlockComponent,
    DeviceDetectorService,
    ConfirmationService
    // DueDateComponent
  ]
})
@RxJSUnsubscribe
export class ProjectWindowComponent implements OnInit, ProjectHolder, OnDestroy, RxJSUnsubscribable {

  project: Project;
  projectAlert: ProjectAlert[];

  projectNumber: number;

  showPlashka: boolean;

  prodCheckListName = environment.trelloProdCheckListName;

  checkLists: TrelloChecklist[] = [];

  projectActivitiesIsLoading = true;
  punchCheckListIsLoading = true;

  // obsArray: Observable<HttpEvent<string>>[] = []

  mapLocation: string;

  editItem: number;

  apiUrl = environment.apiUrl;

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  notification: Notification;
  serviceOrderIdToScroll: number;

  fileOpenedStatus = false;

  escEventListener = null;

  showCvTooltip = false;
  currentUser: User;

  nfsContactTemplate: ContactInfo = {
    id: -1,
    name: 'No Selected Contact'
  }

  constructor(
    private snackBar: MatSnackBar,
    private projectService: ProjectService,
    protected projectsQuery: ProjectsQuery,
    protected appStateQuery: AppStateQuery,
    protected projectWindowQuery: ProjectWindowQuery,
    protected projectWindowStore: ProjectWindowStore,
    protected elementRef: ElementRef,
    protected appRef: ApplicationRef,
    private trelloService: TrelloService,
    private projectActivityService: ProjectActivityService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ProjectWindowComponent>,
    protected filesBlockComponent: FilesBlockComponent,
    protected viewContainerRef: ViewContainerRef,
    protected confirmationService: ConfirmationService,
    protected renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) private data: {
      projectNumber: number,
      projectCode?: string
      notification?: Notification,
      serviceOrderIdToScroll?: number
    }
  ) {
    this.projectNumber = data.projectNumber;
    this.notification = data.notification;
    this.serviceOrderIdToScroll = data.serviceOrderIdToScroll;

    this.appStateQuery.currentUser$.subscribe(user => {
      this.currentUser = user;
    })

  }

  ngOnInit() {

    this.escEventListener = (event: KeyboardEvent) => {
      const key = (event as KeyboardEvent).key; // const {key} = event; in ES6+
      if (key === 'Escape') {
        this.dialog.closeAll();
      }

    }

    document.addEventListener('keydown', this.escEventListener);

    let getProjectService = this.projectService.getProject(this.projectNumber)

    if (this.data.projectCode) {
      getProjectService = this.projectService.getProjectByNumber(this.data.projectCode)
    }

    getProjectService.subscribe(project => {
      this.project = project;

      this.showPlashka = true;

      if (this.project.location) {
        this.mapLocation = this.project.location
      }


      if (this.project.card.checklists === null || typeof this.project.card.checklists === 'undefined') {
        this.punchCheckListIsLoading = true;
        forkJoin([this.trelloService
          .getGroupedPunchList(this.project.id), this.trelloService.getChecklists(this.project.id)])
          .subscribe(result => {
            const punchlist = result[0] as TrelloChecklist;
            const checklistsArr = result[1] as TrelloChecklist[];

            if (punchlist) {
              this.project.card.checklists = [punchlist].concat(checklistsArr)
            } else {
              this.project.card.checklists = checklistsArr
            }

            this.findPunchChecklist();
          })
      } else {
        this.findPunchChecklist();
      }

      this.trelloService.saveCheckItems$
        .pipe(
          takeUntil(this.getUnsubFromAllSubs())
        )
        .subscribe(() => {
          this.findPunchChecklist()
        })

      this.projectActivitiesIsLoading = true;
      this.getProjectActivities();

      merge(
        this.projectActivityService
          .projectActivityEmitter
          .add
          .pipe(filter(event => event.entity.project.id === this.project.id))
          .pipe(
            tap(event => {
                  if (this.project.activities && !this.project.activities.find(act => act.id === event.entity.id)) {
                    this.project.activities.push(event.entity);
                  }
                }
            )
        ),

        this.projectActivityService
          .projectActivityEmitter
          .update
          .pipe(filter(event => event.entity.project.id === this.project.id))
          .pipe(
            tap(event => {
                  if (this.project.activities) {
                    const index = this.project.activities.findIndex(pa => pa.id === event.entityId);
                    if (index >= 0) {
                      this.project.activities[index] = event.entity;
                    } else {
                      this.project.activities.push(event.entity);
                    }
                  }
                }
          )),

        this.projectActivityService
          .projectActivityEmitter
          .remove
          .pipe(filter(event => this.project.activities.findIndex(pa => pa.id === event.entityId) >= 0))
          .pipe(
              tap(event => {
                    this.project.activities = this.project.activities.filter(pa => pa.id !== event.entityId)
                  }
              )
          )
      )
        .pipe(
          takeUntil(this.getUnsubFromAllSubs()),
          debounceTime(50),
          distinctUntilChanged()
        )
        .subscribe(() => {
          this.getProjectActivities();
        })

      this.projectActivityService.getActivityTypes().subscribe()
    }, error => {
      if (this.activeSnackBar) {
        this.activeSnackBar.dismiss();
      }

      this.activeSnackBar = this.snackBar.open(error.message, '', {
        duration: 5000,
        panelClass: 'error-project-snackbar',
        verticalPosition: 'top',
      });

      this.dialogRef.close();
    })

  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.escEventListener);
  }

  findPunchChecklist() {
    let punchList: TrelloChecklist;
    this.project.card.checklists.forEach(checkList => {
      if (this.prodCheckListName !== checkList.name) {
        this.checkLists.sort()

        // checkList.checkItems.sort((x, y) => {
        // 	return (!x.ready === !y.ready) ? 0 : x ? -1 : 1;
        // });

        this.checkLists.push(checkList)

        this.serviceOrderScrollToView()
      }
    });

    punchList = this.project.card.checklists.find(list => list.name === environment.trelloPunchCheckListName)

    if (punchList && punchList.checkItems) {
      punchList.checkItems.forEach(item => {
        if (item.tags) {
          item.tags.sort((taga, tagb) => taga.type.pos - tagb.type.pos)
        }
      })
    }


    this.punchCheckListIsLoading = false;

    if (this.notification) {
      this.nfsScrollToView(this.notification)
    }

  }

  getProjectActivities() {
    this.projectActivityService.getProjectActivities(this.project.id).subscribe(projectActivities => {
      this.project.activities = projectActivities
      this.projectActivitiesIsLoading = false;
    })

  }

  openLastDrawing(): void {
    // this.sendData.emit(this.currentUser)
    const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: this.project.name,
        link: '/project/' + this.project.id + '/files/last-drawing',
        showSendButton: true
      },
      panelClass: 'pdf-preview-dialog'
    });
    cpDialogRef.afterOpened().subscribe(() => {
      // this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'none')
    })
    cpDialogRef.afterClosed().subscribe(() => {
      // this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'flex')
    })
  }

  openProposal(): void {
    // this.sendData.emit(this.currentUser)
    const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: this.project.name,
        link: '/project/' + this.project.id + '/files/last-proposal',
        showSendButton: true
      },
      panelClass: 'pdf-preview-dialog'
    });
    cpDialogRef.afterOpened().subscribe(() => {
      // this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'none')
    })
    cpDialogRef.afterClosed().subscribe(() => {
      // this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'flex')
    })
  }


  openPdfLabels(): void {
    // this.sendData.emit(this.currentUser)
    const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: this.project.name,
        link: '/project/' + this.project.id + '/label',
        showSendButton: true
      },
      panelClass: 'pdf-preview-dialog'
    });
    cpDialogRef.afterOpened().subscribe(() => {
      this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'none')
    })
    cpDialogRef.afterClosed().subscribe(() => {
      this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'flex')
    })
  }

  openProjectActivityWindow(): void {
    this.projectActivityService.getActivityTypes().subscribe(types => {
      const dialogRef = this.dialog.open(ProjectActivityDialogComponent, {
        data: {project: this.project, buttonLabel: 'Add', types},
        disableClose: true,
        panelClass: 'project-activity-dialog'
      });

      dialogRef.afterClosed().subscribe(() => {
        this.getProjectActivities();
      });

    })
  }

  dropFile(files: FileList) {

    const fileArray = [];

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < files.length; i++) {
      fileArray.push(files[i])
    }

    this.projectService.uploadFile(fileArray, this.project.id).subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.UploadProgress) {
        const progressEvent = httpEvent as HttpProgressEvent
        this.filesBlockComponent.updateProgressBar(Math.ceil(progressEvent.loaded / progressEvent.total * 100 / 3) * 3)


      } else if (httpEvent.type === HttpEventType.Response) {
        const projectFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
        this.project.files = this.project.files.concat(projectFiles)
        this.filesBlockComponent.updateProgressBar(0)
      }
    }, error => {
      this.openSnackBar(error.message)
    })
  }

  openSnackBar(message: string, duration = null) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }

    const calculatedDuration = duration !== null
        ? duration
        : Math.min(2000 + message.length * 50, 15000);
    // console.log(message, 'duration', calculatedDuration)

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration: calculatedDuration,
      panelClass: 'file-error-snackbar',
      verticalPosition: 'top',
    });
  }

  copyProjectNumber() {
    const el = document.createElement('textarea');
    // tslint:disable-next-line: deprecation
    el.value = this.project.number;

    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    this.showPlashka = false;


    timer(1000).subscribe(() => {
      this.showPlashka = true;
    })

    // this.projectNumberOP.show(null, this.elementRef.nativeElement.getElementsByClassName('plashka-number')[0]);
  }

  serviceOrderScrollToView() {
    timer(100).subscribe(() => {
      const serviceOrderElem = document.getElementById('' + this.serviceOrderIdToScroll)

      if (serviceOrderElem) {

        timer(500).subscribe(() => {
          serviceOrderElem.classList.add('HIGHLIGHT-TASK');
        })

        timer(2500).subscribe(() => {
          serviceOrderElem.classList.remove('HIGHLIGHT-TASK');
        })


        serviceOrderElem.scrollIntoView({block: 'center', behavior: 'smooth'})
      }
    })
  }

  nfsScrollToView(nfs: Notification) {
    if (nfs.clazz === 'MENTION_NOTIFICATION') {

      timer(1000).subscribe(() => {
        const comm = document.getElementById('' + nfs.entityId)

        if (comm) {

          if (comm.children.item(0).children.item(0).classList.contains('parent-comm')) {
            timer(500).subscribe(() => {
              comm.classList.add('HIGHLIGHT-COMMENT');
            })

            timer(1500).subscribe(() => {
              comm.classList.remove('HIGHLIGHT-COMMENT');
            })
          } else {
            timer(500).subscribe(() => {
              comm.classList.add('HIGHLIGHT-COMMENT-CHILD');
            })

            timer(1500).subscribe(() => {
              comm.classList.remove('HIGHLIGHT-COMMENT-CHILD');
            })
          }

          comm.scrollIntoView({block: 'center', behavior: 'smooth'})
        }

      })

    }
  }

  recalculateAllActivities() {
    this.confirmationService.confirm({
      key: 'recalculate',
      header: 'Recalculate activities?',
      message: `Recalculate All Activities?`,
      accept: () => {
        this.projectActivityService.recalculateActivities(this.project.id)
            .subscribe(activities => {
              this.project.activities = activities;
                },
                error => {
                  if (error instanceof MvcExceptionResponse) {
                    if (error.type === 'project.ProjectException') {
                      this.openSnackBar(error.message)
                    }
                  }
                })
      }
    });
  }

  deleteAllActivities() {
    this.confirmationService.confirm({
      key: 'delete',
      message: `Delete All Activities?`,
      accept: () => {
        this.projectActivityService.deleteActivities(this.project.id)
          .subscribe(ids => {
              this.project.jobDeliveryDate = null;
              this.project.punchListDueDate = null;
              this.project.clientPickupDate = null;
              this.project.finishDate = null;

              (ids as number[])?.forEach(projectActivityId => {
                this.project.activities = this.project.activities.filter(pa => pa.id !== projectActivityId)
              })
              // this.getProjectActivities();
            },
            error => {
              console.error('activities remove error', error);
              if (error instanceof MvcExceptionResponse) {
                if (error.type === 'project.ProjectException') {
                  this.openSnackBar(error.message)
                }
              }
            })
      }
    });
  }

  fileOpened() {
    this.fileOpenedStatus = !this.fileOpenedStatus;

    if (this.fileOpenedStatus) {
      document.removeEventListener('keydown', this.escEventListener);
    } else {
      document.addEventListener('keydown', this.escEventListener);
    }
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  toggleCvTooltip(event: Event) {
    event.stopPropagation();
    this.showCvTooltip = !this.showCvTooltip;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const cvBlock = target.closest('.cv-sync-block');
    if (!cvBlock && this.showCvTooltip) {
      this.showCvTooltip = false;
    }
  }

}
